import { FETCH_EMERGENCY_BANNER, SET_EMERGENCY_BANNER } from 'store/ducks/emergencyBanner/types';
export function fetchEmergencyBanner() {
  return { type: FETCH_EMERGENCY_BANNER };
}

export function setEmergencyBanner(data) {
  return { type: SET_EMERGENCY_BANNER, payload: data };
}
